import { ErrorHandler, EnvironmentProviders, Provider, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ANALYTICS_CONFIG, AnalyticsConfig } from './analytics.config';
import { AnalyticsErrorHandler } from './error-tracking.service';
import { loadGtag } from './gtag.loader';

export function provideAnalytics(config: AnalyticsConfig): EnvironmentProviders {
    const providers: (Provider | EnvironmentProviders)[] = [
        { provide: ANALYTICS_CONFIG, useValue: config },
        { provide: ErrorHandler, useClass: AnalyticsErrorHandler },
        provideAppInitializer(() => {
            // Carrega gtag.js assincronamente — não bloqueia bootstrap.
            void loadGtag(config);
        })
    ];
    return makeEnvironmentProviders(providers);
}
